/**
 * The values are not the full error we receive from the server,
 * we instead receive an error like: "Patient not found: NoMatchFound"
 */
export enum PatientListAddPatientServerErrors {
    NoMatchFound = "NoMatchFound",
    NhsNumberNotVerified = "NhsNumberNotVerified",
    MultipleMatches = "MultipleMatches",
}
